import { css } from '@emotion/css'
import colors from '@styles/colors';

import { mobileOnly, smallMobile, tabletPortraitUp, tabletLandscapeUp, desktopUp } from '@styles/breakpoints';
import peppaIcon from "@img/box-builder/peppa-pig.svg";

export default {
    upgradeBox: css({
        width: '100%',
        height: '100%',
        backgroundColor: colors.WHITE_95,
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 0,
        left: 0,
        'z-index': 3,
        alignItems: 'center',
        alignContent: 'center',
        flexWrap: 'nowrap',
        justifyContent: 'center',

        h3: {
            fontWeight: 800,
            fontSize: 22,
            letterSpacing: '0.02em',
        },
        'button.primary, button.secondary': {
            maxWidth: 202,
            width: '100%',
            fontWeight: 'bold',
            fontSize: 13,
        },
        'button.button.secondary.blue': {
            color: colors.BLUE,
            borderColor: colors.BLUE,
        },
        'button.link': {
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: `13px !important`,
            textDecorationLine: 'underline',
            textTransform: 'none',
            color: `${colors.BLUE} !important`,

            '&::after': {
                content: 'none',
                display: 'none'
            }
        }
    }),
    boxTabsMobile: css({
        backgroundColor: colors.BLUE_EXTRA_LIGHT,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        'z-index': 4,
        height: '60px !important',

        [desktopUp]: {
            display: 'none'
        },

        '.tab': {
            width: '100%',
            height: '100%',
            borderRadius: '10px 10px 0 0',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',

            '&.active': {
                backgroundColor: colors.WHITE,
                borderColor: colors.BLUE,

                '.wrapper': {
                    borderColor: colors.BLUE,
                }
            },

            '.wrapper': {
                height: 60,
                minWidth: 80,
                borderBottom: `${colors.BLUE_EXTRA_LIGHT} solid 5px`,
                width: 'auto',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',

                img: {
                    maxWidth: 24,
                    height: 24,
                    marginRight: 13
                },

                '.text': {
                    color: colors.BLUE,
                    fontSize: 15,
                    lineHeight: 1.6,
                    fontWeight: 'bold',
                    paddingRight: 10,

                    '&.full': {
                        color: colors.GREEN_BRIGHT,
                    }
                }
            }
        }
    }),

    initial: css({
        backgroundColor: 'rgba(235, 238, 246, 1)',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 580,

        h3: {
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: 12,
            textAlign: 'center',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: 20,
        },
        h1: {
            fontStyle: 'normal',
            fontWeight: 800,
            fontSize: 32,
            textAlign: 'center',
            letterSpacing: '0.02em',
            marginBottom: 40,
            [mobileOnly]: {
                fontSize: 26,
            }
        },
        '.blueprints': {
            marginBottom: 52,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            height: 'auto !important',
            [mobileOnly]: {
                marginBottom: 40,
            },

            '.blueprint': {
                display: 'flex',
                flexWrap: 'nowrap',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                width: 140,
                height: 140,
                background: colors.WHITE,
                border: `solid 2px ${colors.BLUE_LIGHT}`,
                borderRadius: 8,
                margin: 5,
                [mobileOnly]: {
                    width: 140,
                    height: 140,
                },

                '&.active': {
                    border: `solid 2px ${colors.BLUE}`,
                },
                img: {
                    width: 25,
                    height: 25,
                },
                '.name': {
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontSize: 16,
                    textAlign: 'center',
                    letterSpacing: '0.01em',
                },
                '.size': {
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 14,
                    textAlign: 'center',
                    letterSpacing: '0.01em',
                }
            }
        },
        button: {
            width: 180,
        }
    }),

    pageContainer: css({
        padding: '0px !important',

        '.header-progress-wrap': {
            width: '100%',
            padding: '11px 34px 9px 34px',
            backgroundColor: colors.BLUE_EXTRA_LIGHT,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',

            [mobileOnly]: {
                justifyContent: 'flex-start',
                position: 'sticky',
                top: 50,
                zIndex: 4,
            },
            '.progress-text': {
                fontWeight: 600,
                fontSize: 15,
                margin: '0 auto',
                lineHeight: '135%',
                letterSpacing: '0.02em',
                color: colors.BLUE,
                '.progress-text-count': {
                    color: colors.GREEN_BRIGHT,
                },
                '.button.link.secondary': {
                    fontSize: 15,
                    letterSpacing: '0.02em',
                    lineHeight: '20.25px',
                    textDecoration: 'underline',
                    color: colors.GREEN_BRIGHT,
                    [mobileOnly]: {
                        marginLeft: 0,
                    },
                },
            },
            '&.box-full': {
                backgroundColor: colors.MINT,
                transition: 'background-color 500ms linear',
            }

        },
    }),

    container: css({
        height: '100%',

        '&:before': {
            [tabletLandscapeUp]: {
                display: 'none',
            },
            '@media screen and (min-width: 999px)': {
                display: 'block',
            },
        },
        flexWrap: 'wrap',
        [tabletPortraitUp]: {
            margin: '0px',
            padding: 0,
        },
        [tabletLandscapeUp]: {
            flexWrap: 'initial',
        },
        '&.leave-it-here-for-now': {
            backgroundColor: colors.TRANSPARENT,
        },
        'h1.desktop': {
            display: 'none',
            [tabletLandscapeUp]: {
                display: 'block',
            }
        },
        'h1.mobile': {
            display: 'block',
            maxWidth: '100%',
            padding: '0 25px',
            margin: '0 auto',
            marginBottom: 15,
            marginTop: 30,
            fontSize: 24,
            [tabletPortraitUp]: {
                maxWidth: 564,
                padding: '0 15px',
            },
            [tabletLandscapeUp]: {
                display: 'none',
            }
        },
        '.show-mobile': {
            display: 'block !important',
            backgroundColor: `${colors.WHITE}  !important`,

            '.box-content-wrap': {
                backgroundColor: `${colors.WHITE}  !important`,
            },
            /*
            '&.shop-cart': {
                [desktopUp]: {
                    backgroundColor: `${colors.PICK_A_PLAN_CONTAINER}  !important`,
                },
            },
            */

            [desktopUp]: {
                display: 'initial !important',
            },
        },
        '.hide-mobile': {
            display: 'none !important',

            [desktopUp]: {
                display: 'initial !important',
            },
        },
        '.shop-wrapper': {
            width: '100%',
            height: '100%',
            paddingTop: 50,

            '.shop-products-wrapper': {
                display: 'flex',
                height: '100%',

                [mobileOnly]: {
                    flexDirection: 'column',
                },
                [tabletPortraitUp]: {
                    flexDirection: 'column',
                },
                [tabletLandscapeUp]: {
                },
                [desktopUp]: {
                    flexDirection: 'row',
                },
            },
            '.builder-cart-amount': {
                display: 'inline-flex',
                alignItems: 'center',
                marginTop: 14,
                marginLeft: 24,
                padding: '10px 20px',
                gap: 16,
                borderRadius: 40,
                span: {
                    fontWeight: 'bold',
                    fontSize: 15,
                    lineHeight: '145%',
                    letterSpacing: '0.01em',
                    color: colors.BLUE,
                },
                '&.empty': {
                    backgroundColor: colors.PINK_EXTRA_LIGHT,
                },
                '&.not-empty': {
                    backgroundColor: colors.TEAL_EXTRA_LIGHT,
                },
            },
            '.shop-cart': {
                paddingTop: 25,
                paddingLeft: 0,
                paddingRight: 0,
                backgroundColor: colors.PICK_A_PLAN_CONTAINER,
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                height: '100%',
                display: 'none',
                zIndex: 3,

                [desktopUp]: {
                    maxWidth: 477,
                    width: '100%',
                    display: 'block',
                    zIndex: 0,
                },
            },
            '.shop-products-container': {
                maxWidth: 1443,
                width: '100%',
                marginRight: 10,
                scrollbarColor: `${colors.BLUE_LIGHTER} ${colors.WHITE}`,
                scrollbarWidth: 'thin',
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                    width: 8,
                    height: 300,
                },
                '&::-webkit-scrollbar:horizontal': {
                    width: 0,
                    height: 0,
                },
                '&::-webkit-scrollbar-button': {
                    width: 0,
                    height: 0,
                    display: 'none',
                },
                '&::-webkit-scrollbar-corner': {
                    backgroundColor: 'transparent',
                    borderRadius: 20,
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: 8,
                    background: '#c2c9d2',
                },

                [tabletLandscapeUp]: {
                    marginLeft: 'auto',
                },
                [desktopUp]: {
                    marginLeft: 'auto',
                    height: 'calc(100vh - 60px)',

                },
                '.filters': {
                    backgroundColor: colors.WHITE,
                    position: 'sticky',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    paddingTop: 20,
                    paddingBottom: 20,
                    zIndex: 3,
                    display: 'flex',
                    top: 0,

                    [mobileOnly]: {
                        padding: '30px 24px 15px 24px',
                        flexDirection: 'column',
                    },
                    [tabletPortraitUp]: {
                        padding: '20px 24px 20px 24px',
                    },
                    [tabletLandscapeUp]: {
                        padding: '20px 45px 20px 40px',
                    },
                    '.separator': {
                        height: 2,
                        width: '100%',
                        marginRight: 20,
                        backgroundColor: colors.BLUE_EXTRA_LIGHT,
                        [mobileOnly]: {
                            display: 'none',
                        },
                        [tabletPortraitUp]: {
                            display: 'none',
                        },
                        [tabletLandscapeUp]: {
                            display: 'block',
                        },
                    },
                },
                '.filter-row': {
                    [mobileOnly]: {
                        overflow: 'hidden',
                        marginLeft: -24,
                        marginRight: -24,
                        width: '100vw',
                    }
                },
                '.filter': {
                    listStyleType: 'none',
                    [mobileOnly]: {
                        marginBottom: 0,
                        flexWrap: 'nowrap',
                        padding: '0 30px',
                        overflow: 'auto',
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                        userSelect: 'none',
                        touchAction: 'manipulation !important',
                        '&::-webkit-scrollbar': {
                            width: 0,  /* Remove scrollbar space */
                            height: 0,
                            background: 'transparent',  /* Optional: just make scrollbar invisible */
                        },
                    },

                    '&.category': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        // gap: 30,
                        [mobileOnly]: {
                            width: '100%',
                            justifyContent: 'flex-start',
                            // gap: 24,
                        }
                    },
                    li: {
                        display: 'block',
                        fontSize: 16,
                        lineHeight: '145%',
                        letterSpacing: '0.01em',
                        textDecoration: 'none',
                        cursor: 'pointer',
                        whiteSpace: 'pre',
                        color: colors.BLUE_50,
                        fontWeight: 800,
                        marginRight: 30,
                        [mobileOnly]: {
                            fontSize: 15,
                            marginRight: 24,
                        },
                        '&.active': {
                            color: colors.NAVY,
                        },
                        '&:last-child': {
                            marginRight: 0,
                            [tabletLandscapeUp]: {
                                marginRight: 20,
                            }
                        },
                    }
                },
                '.filter-actions': {
                    flexDirection: 'row',
                    paddingLeft: 24,
                    paddingRight: 24,
                    display: 'flex',
                    width: 200,
                    marginRight: 24,

                    [mobileOnly]: {
                        marginRight: 0,
                        display: 'none',
                        width: '100%',
                        flexWrap: 'nowrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        alignContent: 'center',
                    },

                    '&.mobile': {
                        display: 'none',
                        [mobileOnly]: {
                            display: 'flex',
                        },
                    },

                    [tabletPortraitUp]: {
                        '&.with-reset': {
                            width: 254
                        },
                    },

                    '.select-dropdown': {
                        width: 200,
                        [mobileOnly]: {
                            width: '100%',
                        },
                    },

                    'button.reset': {
                        padding: 0,
                        border: 0,
                        marginRight: 15,
                        textTransform: 'capitalize',
                        fontSize: 15,
                        lineHeight: '135%',
                        letterSpacing: '0.02em',
                        display: 'block',

                        [mobileOnly]: {
                            display: 'none',
                        },

                        '&.mobile': {
                            marginLeft: 25,
                            marginRight: 0,
                            display: 'none',
                            [mobileOnly]: {
                                display: 'block',
                            }
                        }
                    },

                    '.nutrient': {
                        [mobileOnly]: {
                            display: 'block',
                            width: '100%',
                            marginTop: 15,
                        },
                        [tabletPortraitUp]: {
                            //display: 'none',
                        },
                        [tabletLandscapeUp]: {
                            display: 'block',
                        },
                        '.select-dropdown': {
                            [mobileOnly]: {
                                width: '100%',
                            },
                            '.select__control': {
                                border: `solid 2px rgba(56,86,167,0.2)`,
                            }
                        }
                    }
                },
                '.products-wrapper': {
                    [mobileOnly]: {
                        padding: '21px 24px 20px 24px',
                    },
                    [tabletPortraitUp]: {
                        padding: '0px 24px 20px 24px',
                    },
                    [tabletLandscapeUp]: {
                        padding: '0 40px 20px 40px',
                    },
                    [desktopUp]: {
                    },
                },
                '.category': {
                    '.title': {
                        marginBottom: 26,
                        h2: {
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            fontWeight: 700,

                            [mobileOnly]: {
                                fontSize: 22,
                                lineHeight: '135%',
                            },
                            'span:nth-child(1)': {
                                marginRight: 15,
                            },
                            'span:nth-child(2)': {
                                color: colors.BLUE,
                                fontWeight: 600,
                                fontSize: 15,
                                lineHeight: '135%',
                                paddingTop: 6,

                                [smallMobile]: {
                                    marginLeft: 0,
                                }
                            },
                        },
                    },
                    '.products-row': {
                        display: 'grid',
                        gridGap: 10,
                        [mobileOnly]: {
                            gridTemplateColumns: '1fr 1fr',
                        },
                        [tabletPortraitUp]: {
                            gridTemplateColumns: '1fr 1fr 1fr',
                        },
                        [tabletLandscapeUp]: {
                            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                        },
                        '.product-wrapper': {
                            display: 'flex',
                            [mobileOnly]: {
                                marginBottom: 27,
                            },
                            [tabletPortraitUp]: {
                                marginBottom: 27,
                            },
                            [tabletLandscapeUp]: {
                                marginBottom: 54,
                            },
                        },
                        '.product': {
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            '.product-link': {
                                cursor: 'pointer',
                            },
                            '.image': {
                                maxWidth: '100%',
                                borderRadius: 5,
                                overflow: 'hidden',

                                picture: {
                                    display: 'block',
                                    minHeight: 140,
                                },

                                img: {
                                    maxWidth: '100%',
                                    display: 'block',
                                    transition: 'all 0.3s ease 0s',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                    },
                                },
                            },
                            '.star-wrapper': {
                                position: 'absolute',
                                top: 10,
                                left: 5,
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                flexWrap: 'wrap',
                                flexDirection: 'row',
                                width: '50%',
                                alignContent: 'center',
                                img: {
                                    marginLeft: 5,
                                }
                            },
                            '.title': {
                                margin: '12px 10px 8px',
                                textAlign: 'center',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '145%',
                                letterSpacing: '0.01em',
                                minHeight: 46,
                            },
                            '.action.quantity': {
                                maxWidth: 146,
                                width: '100%',
                                margin: '0 auto',
                                touchAction: 'manipulation',

                            },
                            '.action.shop-now, .action.add': {
                                maxWidth: 146,
                                width: '100%',
                                margin: '0 auto',
                                textAlign: 'center',
                                span: {
                                    cursor: 'pointer',
                                    circle: {
                                        transition: 'fill 0.2s ease',
                                    },
                                    '&:hover': {
                                        circle: {
                                            fill: colors.NAVY,
                                        }
                                    }
                                },
                                img: {
                                    cursor: 'pointer',
                                },
                            },
                            '.new-info': {
                                display: 'none',
                                top: 8,
                                right: 8,
                                padding: '5px 6px',
                                position: 'absolute',
                                color: colors.NAVY,
                                backgroundColor: colors.WHITE,
                                textTransform: 'capitalize',
                                fontWeight: 400,
                                fontSize: 10,
                                lineHeight: '10px',
                                textAlign: 'center',
                                letterSpacing: '0.1em',
                                borderRadius: '2px',
                                fontFamily: "'sofia-pro', sans-serif",
                                boxSizing: 'border-box',
                            },
                            '.out-of-stock-info': {
                                display: 'none',
                                width: 56,
                                height: 56,
                                borderRadius: 28,
                                paddingTop: 18,
                                top: 10,
                                right: 10,
                                position: 'absolute',
                                transform: 'rotate(15deg)',
                                color: colors.WHITE,
                                backgroundColor: colors.RED,
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                fontSize: '10px',
                                lineHeight: '10px',
                                textAlign: 'center',
                                letterSpacing: '0.1em',
                                boxSizing: 'border-box', //mobile safari OS bug fixing
                            },
                            '.out-of-stock-button': {
                                textAlign: 'center',
                                'button': {
                                    '&:hover': {
                                        color: colors.WHITE,
                                    },
                                }
                            },
                            '.out-of-stock-modal': {
                                textAlign: 'center',
                                display: 'flex',
                            },
                            '.recommended-info': {
                                display: 'none',
                                top: 10,
                                right: 10,
                                position: 'absolute',
                                color: colors.NAVY,
                                backgroundColor: colors.WHITE,
                                borderRadius: 2,
                                fontSize: 10,
                                lineHeight: '10px',
                                padding: '5px 6px',
                                letterSpacing: '0.01em',
                            },
                            '.peppa-pig': {
                                display: 'none',
                                top: 8,
                                right: 8,
                                position: 'absolute',
                                backgroundImage: `url(${peppaIcon})`,
                                width: 54,
                                height: 31,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'contain'
                            },
                            '.actions': {
                                '.quantity': {
                                    maxWidth: 145,
                                    margin: 'auto',
                                    userSelect: 'none',
                                }
                            },
                            '&.out-of-stock': {
                                '&:not(.with-amount)': {
                                    '.action': {
                                        display: 'none',
                                    },
                                },
                                '.out-of-stock-info': {
                                    display: 'block',
                                },
                            },

                            '&.new': {
                                '.new-info': {
                                    display: 'block',
                                },
                            },
                            '&.recommended': {
                                '.recommended-info': {
                                    display: 'block',
                                }
                            },
                            '&.peppa': {
                                '.peppa-pig': {
                                    display: 'none',
                                }
                            }
                        },
                    },
                },
            },
        },
    }),
};
